// src/constants/sidebarItems.js
import {
    Dashboard,
    Settings,
    Public,
    Flag,
    People,
    Category,
    Commute,
    DesignServices,
    Store,
    Tour,
    Inventory2,
    ViewModule,
    Person,
    Security,
    AttachMoney,
    MonetizationOn,
} from '@mui/icons-material';


export const sidebarItems = [
    {
        key: 'dashboard',
        label: { en: 'Dashboard', ar: 'لوحة التحكم' },
        path: '/dashboard',
        icon: Dashboard,
    },
    {
        key: 'setting',
        label: { en: 'Setting', ar: 'الأعدادات' },
        path: '/setting',
        icon: Settings,
    },
    {
        key: 'countries',
        label: { en: 'Countries', ar: 'الدول' },
        path: '/countries',
        icon: Public,
    },
    {
        key: 'currencies',
        label: { en: 'Currencies', ar: 'العملات' },
        path: '/currencies',
        icon: AttachMoney,
    },
    {
        key: 'nationalities',
        label: { en: 'Nationalities', ar: 'الجنسيات' },
        path: '/nationalities',
        icon: Flag,
    },
    {
        key: 'paxTypes',
        label: { en: 'Pax Types', ar: 'أنواع الركاب' },
        path: '/pax-types',
        icon: People,
    },
    {
        key: 'productTypes',
        label: { en: 'Product Types', ar: 'أنواع المنتجات' },
        path: '/product-types',
        icon: Inventory2,
    },
    {
        key: 'pricingUnits',
        label: { en: 'Pricing Units', ar: 'وحدات التسعير' },
        path: '/pricing-units',
        icon: MonetizationOn,
    },
    {
        key: 'transportations',
        label: { en: 'Transportations', ar: 'وسائل النقل' },
        path: '/transportations',
        icon: Commute,
    },
    {
        key: 'categories',
        label: { en: 'Categories', ar: 'التصنيفات' },
        path: '/categories',
        icon: Category,
    },
    {
        key: 'packages',
        label: { en: 'Tour Options', ar: 'خيارات الجولات' },
        path: '/packages',
        icon: Tour,
    },
    {
        key: 'services',
        label: { en: 'Services', ar: 'الخدمات' },
        path: '/services',
        icon: DesignServices,
    },
    {
        key: 'suppliers',
        label: { en: 'Suppliers', ar: 'الموردون' },
        path: '/suppliers',
        icon: Store,
    },
    {
        key: 'products',
        label: { en: 'Products', ar: 'المنتجات' },
        path: '/products',
        icon: Inventory2,
    },
    {
        key: 'programs',
        label: { en: 'Programs', ar: 'البرامج' },
        path: '/programs',
        icon: ViewModule,
    },
    {
        key: 'users',
        label: { en: 'Users', ar: 'المستخدمون' },
        path: '/users',
        icon: Person,
    },
    {
        key: 'roles',
        label: { en: 'Roles', ar: 'الأدوار' },
        path: '/roles',
        icon: Security,
    },
];
/**
 * جميل الآن ابدأ ببناء ال Currencies بنفس الستركتشر والديزاين باتيرن واللوجيك ونفس طريقة الكود التي نعمل بها دون اي تعديل 
 * */ 